import { Depot, Instance, Objekt, Promize, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { LanguageService } from '@services/languageService';
import { ReportPersonService } from '@services/reportPersonService';
import { ReportService } from '@services/reportService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class ReportsPeopleHowMuchHuntController extends DashboardController {
    static readonly inject = [
        'instances',
        'reportService',
        'reportPersonService',
        'assetService',
        'languageService',
    ] as const;

    localDepot: Depot;
    table!: Table;

    constructor(
        instances: Instance,
        private reportService: ReportService,
        private reportPersonService: ReportPersonService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.localDepot = instances.localDepot;
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initReportTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-reports-index', this.dom, () => {
            this.state.goBack('reports.index');
        });

        this.helper.fabButton('.btn-reports-filter', this.dom, () => {
            this.reportService.detailsDialog('people');
        });
    }

    private _initReportTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            null,
            {
                entityKey: 'objects',
                fetchData: (params) => {
                    const peopleReport = new Objekt(
                        this.localDepot.get(
                            this.reportService.getStorageKeyReport('people'),
                        ),
                    );
                    return this.reportService.getAllByPeople(
                        peopleReport,
                        params,
                    );
                },
                extraParams: (params) => {
                    params.set(
                        'fields',
                        'id,full_name,sum_duration,hunts_count,trophies_count,sum_duration_prev,hunts_count_prev,trophies_count_prev',
                    );
                },
            },
            undefined,
            undefined,
            undefined,
            {
                no_content: {
                    image_url: this.assetService.getPath(
                        'images/others/no-content.png',
                    ),
                    text: this.languageService.translate('text.no_content'),
                },
                sort: {
                    column: 'sum_duration',
                    order: 'desc',
                },
                row_count: 1000,
                column: 'full_name',
                columns: [
                    'number',
                    'full_name',
                    'sum_duration',
                    'hunts_count',
                    'trophies_count',
                ],
                sorted: [
                    'full_name:asc',
                    'sum_duration:desc',
                    'hunts_count:desc',
                    'trophies_count:desc',
                ],
                calculations: this.reportPersonService.getTableCalculations(),
            },
        ) as Table;
    }
}

export const reportsPeopleHowMuchHuntController = app.controller(
    'reportsPeopleHowMuchHuntController',
    ReportsPeopleHowMuchHuntController,
);
